//react
import React from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import CommonUtils from "./Utils/CommonUtils";

//stripe-resource
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

//interceptors
import {
  initializeInterceptors,
  removeInterceptors,
} from "./Communication/AxiosInterceptor";

//constants/ actions/ utils
import { PATHS } from "./Constants";
import { LoginAction } from "./Components/Login/LoginAction";
import LovedOne from "./Components/Dashboard/LovedOne/LovedOne";

//styling
import "./App.scss";
import InvitationHandler from "./Components/InvitationHandler/InvitationHandler";
import LoginContainer from "./Components/Login/Login";
import AppContainer from "./Components/LandingApp/index";
import DashboardContainer from "./Components/Dashboard/DashboardContainer";
import NavigationBar from "./Components/NavigationBar/NavigationBar";
import CareCircle from "./Components/CareCircle/CareCircle";
import Settings from "./Components/Settings/Settings";
import Alerts from "./Components/Alert/Alert";
import TopNavigationBar from "./Components/TopNavigationBar/TopNavigationBar";
import ShowDemoData from "./Components/ShowDemoData/ShowDemoData";
import Report from "./Components/Dashboard/Report/Report";
import SelfData from "./Components/Dashboard/SelfData/SelfData";
import Plans from "./Components/Plans/Plans";
import UpgradeHandler from "./Components/UpgradeHandler/UpgradeHandler";
import PlansCheckout from "./Components/Plans/PlansCheckout/PlansCheckout";
import PlanPurchaseSummary from "./Components/Plans/PlanPurchaseSummary/PlanPurchaseSummary";
import CardForm from "./Components/Plans/CardForm/CardForm";
import AddCardContainer from "./Components/Plans/AddCardContainer/AddCardContainer";
import PlanPurchaseSummaryContainer from "./Components/Plans/PlanPurchaseSummary/PlanPurchaseSummaryContainer";

// const LoginContainer = lazy(() => import("./Components/Login/Login"));
// const AppContainer = lazy(() => import("./Components/LandingApp/index"));
// const DashboardContainer = lazy(() =>
//   import("./Components/Dashboard/DashboardContainer")
// );

// const NavigationBar = lazy(() =>
//   import("./Components/NavigationBar/NavigationBar")
// );

// const CareCircle = lazy(() => import("./Components/CareCircle/CareCircle"));

// const Settings = lazy(() => import("./Components/Settings/Settings"));
// const Alerts = lazy(() => import("./Components/Alert/Alert"));
// const TopNavigationBar = lazy(() =>
//   import("./Components/TopNavigationBar/TopNavigationBar")
// );
// const ShowDemoData = lazy(() =>
//   import("./Components/ShowDemoData/ShowDemoData")
// );
const STRIPE_PUBLIC_KEY = `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`;
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onLoggedInPage: false,
      history: createBrowserHistory(),
      lovedOneCountShow: false,
      onShowDemo: false,
      onUpgrade: false,
      showSpinner: true,
    };

    this.loginAction = new LoginAction();
    initializeInterceptors((callback) =>
      this.loginAction.getRefreshTokenAction(callback)
    );
  }


  onRouteChanged = () => {
    console.log("rendered");
  };
  componentWillUnmount() {
    removeInterceptors();
    this.unlisten();
  }
  componentDidMount() {
    this.setState({
      onLoggedInPage:
        this.state.history.location.hash.includes("/login") ||
        (this.state.history.location.hash === "" &&
          this.state.history.location.pathname === PATHS.ROOT),
      lovedOneCountShow: this.state.history.location.hash.includes("/home"),
      onShowDemo: this.state.history.location.hash.includes("/showDemo"),
      onUpgrade: this.state.history.location.hash.includes("/upgrade"),
    });
  }


  componentWillMount() {
    this.unlisten = this.state.history.listen((location, action) => {
      this.setState({
        onLoggedInPage: location.hash.includes("/login"),
      });
    });
    this.unlisten = this.state.history.listen((location, action) => {
      this.setState({
        lovedOneCountShow: location.hash.includes("/home"),
      });
    });
    this.unlisten = this.state.history.listen((location, action) => {
      this.setState({
        onShowDemo: location.hash.includes("/showDemo"),
      });
    });
    this.unlisten = this.state.history.listen((location, action) => {
      this.setState({
        onUpgrade: location.hash.includes("/upgrade"),
      });
    });
  }
  render() {
    let navigationBar =
      this.state.onLoggedInPage === false &&
      this.state.onShowDemo === false && this.state.onUpgrade === false &&
      (!this.props.inviteTokenInfo || !this.props.inviteTokenInfo.isInvitedUser ) ? (
        <NavigationBar path={window.location.hash} />
      ) : null;
    let topNavigationBar =
      this.state.onLoggedInPage === false && this.state.onShowDemo === false && this.state.onUpgrade === false ? (
        <TopNavigationBar
          logout={this.props.logout}
          userInfo={this.props.userInfo}
          invitedUserInfo={this.props.invitedUserInfo}
          inviteTokenInfo={this.props.inviteTokenInfo}
          summeryUserList={this.props.summeryUserList}
          lovedOneCountShow={this.state.lovedOneCountShow}
          path={window.location.hash}
        />
      ) : null;
    return (
      <div className="App">
        <HashRouter>
          {/* <Suspense fallback={<FallbackSpinner />}> */}
          {topNavigationBar}
          <Switch>
            <Route exact path={PATHS.PLANS} component={Plans} />
            <Route exact path={PATHS.ROOT} component={AppContainer} />
            <Route exact path={PATHS.HOME} component={DashboardContainer} />
            <Route exact path={PATHS.LOGIN} component={LoginContainer} />
            <Route exact path={PATHS.SHOWDEMO} component={ShowDemoData} />
            <Route exact path={PATHS.CARECIRCLE} component={CareCircle} />
            <Route exact path={PATHS.ALERTS} component={Alerts} />

            <Route exact path={PATHS.SETTINGS} component={Settings} />
            <Route
              exact
              path={PATHS.HOME + PATHS.LOVED_ONES}
              component={LovedOne}
            />
            <Route
              exact
              path={PATHS.HOME + PATHS.SELF_DATA}
              component={SelfData}
            />
            <Route exact path={PATHS.HOME + PATHS.REPORTS} component={Report} />

            {/* <Route exact path={PATHS.MESSAGE} component={Message} />							 */}

            <Route
              path={PATHS.INVITATION_HANDLER}
              component={InvitationHandler}
            />

            <Route path={PATHS.UPGRADE} component={UpgradeHandler} />

            <Route
              exact
              path={`${PATHS.PLANS}${PATHS.CHECKOUT}`}
              component={PlansCheckout}
            />
            <Route
              exact
              path={`${PATHS.PLANS}${PATHS.PURCHASE_SUMMARY}`}>
              <Elements stripe={stripePromise}>
                <PlanPurchaseSummaryContainer/>
              </Elements>  
              </Route>

            <Route exact path={`${PATHS.PLANS}${PATHS.ADD_CARD_DETAILS}`}>
              <AddCardContainer stripe={stripePromise} />
            </Route>
          </Switch>

          {navigationBar}
          {/* </Suspense> */}
        </HashRouter>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    summeryUserList: state.Dashboard.summeryUserList,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
    // userAccessTokenInfo: state.UpgradeContainer.userAccessTokenInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // dispatching plain actions
    logout: () => dispatch({ type: "CLEAN_LOGIN_DATA" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
